<template>
<nav class="global-nav-pc d-none d-md-block" :class="navClass">
  <b-button :variant="btnClass" class="mr-2" @click="click('top')">TOP</b-button>
  <b-dropdown class="mr-2" text="PROFILE" :variant="btnClass" no-caret>
    <b-dropdown-item @click="click('profile')">PROFILE</b-dropdown-item>
    <b-dropdown-item @click="click('exhibition')">EXHIBITION</b-dropdown-item>
  </b-dropdown>
  <b-dropdown class="mr-2" text="ARTWORK" :variant="btnClass" no-caret>
    <b-dropdown-item @click="click('artwork')">ARTWORK</b-dropdown-item>
    <b-dropdown-item @click="click('artworkMaking')">ART PROCESS</b-dropdown-item>
    <b-dropdown-item  @click="click('pastworks')">PAST ART WORKS</b-dropdown-item>
  </b-dropdown>
  <b-button class="mr-2" :variant="btnClass" @click="click('order')">ORDER</b-button>
  <b-button class="mr-2" :variant="btnClass" @click="click('workshop')">WORKSHOP</b-button>
  <b-button :variant="btnClass" @click="click('contact')">CONTACT</b-button>
  <a href="https://www.facebook.com/Hiraku91/" target="_blank" class="btn" :class="btnBrandClass">
    <font-awesome-icon :icon="['fab', 'facebook']" />
  </a>
  <a href="https://www.instagram.com/hiraku_ueda/" target="_blank" class="btn" :class="btnBrandClass">
    <font-awesome-icon :icon="['fab', 'instagram']" />
  </a>
</nav>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'GlobalNavPc',
  computed: {
    ...mapState({
      homeSwiperIndex: state => state.homeSwiperIndex,
    }),
    navClass() {
      if (this.$route.name == 'Home') {
        if (this.homeSwiperIndex == 0) {
          return 'clear white'
        } else if (this.homeSwiperIndex == 1) {
          return 'white'
        }
        else {
          return ''
        }
      } else {
        return ''
      }
    },
    btnClass() {
      if (this.$route.name == 'Home' && this.homeSwiperIndex == 1) {
        return 'outline-light'
      } else {
        return 'outline-dark'
      }
    },
    btnBrandClass() {
      if (this.$route.name == 'Home' && this.homeSwiperIndex == 1) {
        return 'btn-outline-light'
      } else {
        return 'btn-outline-dark'
      }
    }
  },
  methods: {
    ...mapActions({
      updatePageChange: 'doUpdatePageChanger'
    }),
    click(dist) {
      // console.log(dist)
      if (dist === 'top' || dist === 'profile' || dist === 'artwork' || dist === 'order' || dist === 'workshop' || dist === 'contact') {
        if (this.$route.name == 'Home') {
          location.hash = '#' + dist
          this.updatePageChange()        
        } else {
          this.$router.push({name: 'Home', hash: '#'+dist})
        }
      } else if (dist === 'artworkMaking'){
        this.$router.push({name: 'artworkMaking'})          
      } else if (dist === 'pastworks'){
        this.$router.push({name: 'pastWorks'})          
      } else if (dist === 'exhibition'){
        this.$router.push({name: 'exhibition', params: {pageNo: '1'}})          
      } 
      this.$emit('buttonDidClick')
    }    
  }
}
</script>

<style lang="scss">
.global-nav-pc {
  position: fixed;
  top: 10px;
  right: 30px;
  @media screen and (min-width: 1200px) {
    top: 30px;
    right: 30px;    
  }
  z-index: 11;
  opacity: 1;
  transition: opacity 0.6s;
  &.clear {
    opacity: 0;
    pointer-events: none;
  }
  .btn-outline-dark, .btn-outline-light {
    border-width: 0;
  }
  .dropdown-menu {
    border: none;
    background-color: rgba(255,255,255, 0.7);
    padding-top: 0;
    padding-bottom: 0;
    transform: translate3d(-40px, 46px, 0px) !important;
    >li {
      text-align: center;
      border-bottom: 1px solid #333;
      .dropdown-item {
        padding: 0.5rem 0.5rem;
        &:focus, &:active {
          background-color: #333;
          color: #fff;
        }
      }
    }
    &:before {
      content: '';
      position: absolute;
      top: -7px;
      left: 0;
      width: 100%;
      height: 7px;
      background-image: url('/images/dropdown-arrow.svg');
      background-position: center bottom;
      background-repeat: no-repeat;
    }
  }
}
</style>